import { render, staticRenderFns } from "./ClientCalcCompliancePage.vue?vue&type=template&id=1a38b34e&scoped=true"
import script from "./ClientCalcCompliancePage.vue?vue&type=script&lang=js"
export * from "./ClientCalcCompliancePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a38b34e",
  null
  
)

export default component.exports